import {Injectable} from '@angular/core';
import {PageState} from '../domain/page-state';
import {Observable} from 'rxjs/Observable';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

@Injectable()
export class PageStateService {

    private history = [];
    private savedPageStates: Map<string, PageState> = new Map<string, PageState>();

    constructor(
        private router: Router
    ) {
    }

    public setInitialPage(): void {
        if (this.history.length == 0)
            this.history.push(this.router.routerState.snapshot.url);
    }

    public loadRouting(): void {
        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd)
            )
            .subscribe(({urlAfterRedirects}: NavigationEnd) => {
                if (this.history.length === 5) {
                    this.history.shift();
                }
                this.history.push(urlAfterRedirects);
                this.checkStates();
            });
    }

    public getHistory(): string[] {
        return this.history;
    }

    public getPreviousUrl(): string {
        return this.history[this.history.length - 2] || '/index';
    }

    public getActualUrl(): string {
        return this.history[this.history.length - 1] || '/index';
    }

    /**
     *  Revisa el mapa de estados y elimina los estados que no apliquen solo al caso de voler atras.
     */
    private checkStates(): void {
        const keysToDelete = Array.from(this.savedPageStates.keys())
            .filter(key => (key !== this.getActualUrl()) && (key !== this.getPreviousUrl()));
        for ( let key of keysToDelete ) {
            this.savedPageStates.delete(key);
        }
    }

    saveState(pageState: any) {
        const page = new PageState();
        page.url = this.getActualUrl();
        page.state = pageState;
        this.savedPageStates.set(page.url, page);
    }

    loadState(): Observable<PageState> {
        const previousState: PageState = this.savedPageStates.get(this.getActualUrl());
        return previousState !== undefined ? Observable.of(previousState) : Observable.of(null);
    }
}


// WEBPACK FOOTER //
// ./src/app/core/service/page-state.service.ts